import { n as o } from "./property-BWlAHqg_.js";
import { i as d } from "./query-D8_rwLua.js";
import { x as p } from "./lit-element-6iugfgmM.js";
import { o as a } from "./if-defined-D-RhGngI.js";
var l = Object.defineProperty, c = (n, e, r, h) => {
  for (var s, t = void 0, i = n.length - 1; i >= 0; i--) (s = n[i]) && (t = s(e, r, t) || t);
  return t && l(e, r, t), t;
};
function f(n) {
  class e extends n {
    constructor() {
      super(...arguments), this.checked = !1, this.readonly = !1;
    }
    handleChange() {
      if (this.readonly) return void (this.inputElement.checked = this.checked);
      this.checked = this.inputElement.checked;
      const h = new CustomEvent("change", { bubbles: !0, cancelable: !0, composed: !0 });
      this.dispatchEvent(h) || (this.checked = !this.inputElement.checked, this.inputElement.checked = this.checked);
    }
    render() {
      return p`
                <input
                    id="input"
                    name=${a(this.name || void 0)}
                    type="checkbox"
                    .checked=${this.checked}
                    ?disabled=${this.readonly}
                    @change=${this.handleChange}
                />
            `;
    }
  }
  return c([o({ type: Boolean, reflect: !0 })], e.prototype, "checked"), c([o({ type: String, reflect: !0 })], e.prototype, "name"), c([o({ type: Boolean, reflect: !0 })], e.prototype, "readonly"), c([d("#input")], e.prototype, "inputElement"), e;
}
export {
  f as C
};
//# sourceMappingURL=CheckboxMixin-D0-LsxjI.js.map
